import api from 'api'
import { z } from 'zod'

export const dayforceWebhookDetailSchema = z.object({
  id: z.number(),
  agencyId: z.string(),
  status: z.string(),
  attempts: z.number(),
  payloadBase64: z.string(),
  eventType: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type DayforceWebhookDetail = z.infer<typeof dayforceWebhookDetailSchema>

export const getDayforceWebhook = async (
  webhookId: number
): Promise<DayforceWebhookDetail> => {
  const response = await api.get<unknown>(
    `/admin/dayforce/webhook/${webhookId}`
  )
  return dayforceWebhookDetailSchema.parse(response.data)
}
